import classicMapVariant from "./classic";
import { MapVariant } from "./types";
import worldmapMapVariant from "./worldmap";
import americas1840MapVariant from "./americas1840";

/*
地图注册表：key（如 "classic"）→ MapVariant。
新增一张地图时，把它的 MapVariant 加到这里即可（P1 生成器会自动产出
变体模块并追加注册）。
*/

export const DEFAULT_MAP_VARIANT_KEY = "classic";

const MAP_VARIANTS: { [key: string]: MapVariant } = {
  [americas1840MapVariant.key]: americas1840MapVariant,
  [worldmapMapVariant.key]: worldmapMapVariant,
  [classicMapVariant.key]: classicMapVariant,
};

export function getMapVariantByKey(key: string): MapVariant {
  return MAP_VARIANTS[key] ?? MAP_VARIANTS[DEFAULT_MAP_VARIANT_KEY];
}

export function getAllMapVariants(): MapVariant[] {
  return Object.values(MAP_VARIANTS);
}

/**
 * 根据游戏携带的 variantID / mapID 解析出对应的地图。
 * 匹配不到时回退到默认地图（classic）。
 */
export function resolveMapVariant({
  variantID,
  mapID,
}: {
  variantID?: number;
  mapID?: number;
} = {}): MapVariant {
  const variants = getAllMapVariants();
  if (typeof variantID === "number") {
    const byVariant = variants.find((v) => v.variantIDs.includes(variantID));
    if (byVariant) return byVariant;
  }
  if (typeof mapID === "number") {
    const byMap = variants.find((v) => v.mapID === mapID);
    if (byMap) return byMap;
  }
  return MAP_VARIANTS[DEFAULT_MAP_VARIANT_KEY];
}
